import PaymentGatewayTesterDispatcher from '../dispatcher/PaymentGatewayTesterDispatcher'
import PaymentGatewayTesterConstants from '../constants/PaymentGatewayTesterConstants'

var PaymentGatewayTesterActions = {

  cancelGateway: function () {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.CANCEL_GATEWAY,
    });
  },

  deleteGateway: function (id) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.DELETE_GATEWAY,
      id: id
    });
  },

  init: function (opts) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.INIT,
      opts: opts
    });
  },

  setGateway: function (gateway) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.SET_GATEWAY,
      gateway: gateway,
    });
  },

  setGatewayDefault: function (id, is_default) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.SET_GATEWAY_DEFAULT,
      id: id,
      is_default: is_default,
    });
  },

  setGatewayLive: function(id, is_live) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.SET_GATEWAY_LIVE,
      id: id,
      is_live: is_live,
    });
  },

  newGateway: function () {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.NEW_GATEWAY
    });
  },

  updateGatewayName: function (id, name) {
    PaymentGatewayTesterDispatcher.dispatch({
      action: PaymentGatewayTesterConstants.UPDATE_GATEWAY_NAME,
      id: id,
      name: name,
    });
  },

};

export default PaymentGatewayTesterActions;
